// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DatapointIdFromJSON, DatapointIdToJSON, } from './';
export function DatapointFilterFromJSON(json) {
    return {
        'datapoint': !exists(json, 'datapoint') ? undefined : DatapointIdFromJSON(json['datapoint']),
        'values': !exists(json, 'values') ? undefined : json['values'],
        'operator': json['operator'],
        'minNumberValue': !exists(json, 'minNumberValue') ? undefined : json['minNumberValue'],
        'maxNumberValue': !exists(json, 'maxNumberValue') ? undefined : json['maxNumberValue'],
    };
}
export function DatapointFilterToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'datapoint': DatapointIdToJSON(value.datapoint),
        'values': value.values,
        'operator': value.operator,
        'minNumberValue': value.minNumberValue,
        'maxNumberValue': value.maxNumberValue,
    };
}
/**
* @export
* @enum {string}
*/
export var DatapointFilterOperatorEnum;
(function (DatapointFilterOperatorEnum) {
    DatapointFilterOperatorEnum["In"] = "in";
    DatapointFilterOperatorEnum["Between"] = "between";
    DatapointFilterOperatorEnum["BetweenNumbers"] = "betweenNumbers";
    DatapointFilterOperatorEnum["NotIn"] = "notIn";
})(DatapointFilterOperatorEnum || (DatapointFilterOperatorEnum = {}));
